import {Presenter} from '../../../../Support/with_presenter';
import {WorkoutsService} from '../../../../Network/WorkoutsService';
import {NetworkRequestStatus, NetworkResult, loadingResponse} from '../../../../Network/NetworkResult';
import {CrewsService} from '../../../../Network/CrewsService';
import {FullCrew} from '../../../../Models/Crew';

export class TransferWorkoutPresenter implements Presenter {
    public selectedId = '';
    public crews: NetworkResult<FullCrew[]> = loadingResponse();
    public isSaving = false;
    public isDisabled = true;

    constructor(
        private id: number,
        private originalUserId: number | null,
        private workoutService: WorkoutsService,
        private crewsService: CrewsService,
    ) {}

    public async mount(): Promise<void> {
        this.crews = await this.crewsService.all()
    }

    public unmount(): void {
        /* Noop */
    }

    public checkDisabled(): void {
        this.isDisabled = (this.selectedId === '');
    }

    public setSelectedId(value: string): void {
        this.selectedId = value;
        this.checkDisabled();
    }

    public async submit() {
        if(this.selectedId === ''){
            return
        }
        try {
            this.isSaving = true;
            const result = await this.workoutService.updateUser(this.id, Number(this.selectedId));
            if (result.status === NetworkRequestStatus.Success) {
                window.location.href = '/crews';
            }
        } finally {
            this.isSaving = false;
        }
    }

    public async returnToOwner() {
        if(this.originalUserId === null){
            return
        }
        try {
            this.isSaving = true;
            const result = await this.workoutService.updateUser(this.id, this.originalUserId);
            if (result.status === NetworkRequestStatus.Success) {
                window.location.href = '/crews';
            }
        } finally {
            this.isSaving = false;
        }
    }
}
